/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class RedditOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    error={this.props.error}
                    headerCopy="Select a Subreddit"
                    serviceMessage={(
                        <div>
                            You'll need to be a moderator of a Subreddit before you can connect to Reddit. <a href="https://support.dlvrit.com/hc/en-us/articles/4414445018651" target="_blank">Learn more</a>
                        </div>
                    )}/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={"You've already connected all eligible subreddits to dlvr.it"}
                    noSubaccountMessage={(
                        <div className="chooser-notice no-accounts">
                            We were unable to locate any Subreddits associated with your Reddit account that can be connected to dlvr.it.<br/><br/>
                            This may mean this account doesn't have the necessary posting permissions. You may need to request and accept an invitation to be a moderator of the Subreddit or log into a different account.
                        </div>
                    )}
                    unavailableMessage={"Subreddits you've already connected"}/>
            </div>
        );
    }
}

RedditOutput.displayName = "RedditOutput";

export default RedditOutput;
